import { StyleSheet, Platform } from 'react-native';

export default StyleSheet.create({
  title: (theme, withTopUpSomeOneElseTitle) => ({
    paddingTop: withTopUpSomeOneElseTitle ? 12 : 3,
    paddingBottom: 8,
    color: theme.colors.textColorThree,
  }),
  container: { paddingHorizontal: 0 },
  topupSomeoneElseTitle: {
    paddingTop: Platform.OS === 'ios' ? 18 : 14,
    fontSize: Platform.OS === 'ios' ? 16.6 : 16,
    flex: 1,
    textAlign: 'center',
    marginLeft: 18,
  },
  topupSomeoneElseTitleView: { flex: 1 },
  closeBtnStyle: withTopUpSomeOneElseTitle => ({
    marginTop: withTopUpSomeOneElseTitle ? 12 : 0,
  }),
  backBtnStyle: withTopUpSomeOneElseTitle => ({
    marginTop: withTopUpSomeOneElseTitle ? 10 : 0,
    marginRight: 16,
  }),
  wrapperView: hasKeyboard => ({ minHeight: hasKeyboard ? 300 : null }),
  titleWrapper: {
    paddingTop: '20px',
    backgroundColor: 'white',
    height: '100px',
    textAlign: 'center',
    width: '100%'
  },
  biggerText: {
    fontSize: '28px',
    color: 'rgb(51, 51, 51)'
  },
});
